import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function CarouselItemGeneralAdd({
  item
}) {
  
  return (
    <div
      key={item.id}
      className={`min-w-full h-full relative flex items-center justify-center overflow-hidden transition-transform duration-300 ease-in-out border-2 border-aw-green rounded-lg`}
    >
      {/* Imagen de fondo */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${item.backgroundSrc})` }}
      />

      <div className="grid h-full w-full bg-purple-700/50 backdrop-blur-[0.5px]">
        {/* Contenido del slide */}
        <div className="flex flex-col items-start justify-center relative z-10 text-left select-none text-white px-8 2xl:px-16">
          {item.verified && (
            <span className="text-sm md:text-lg font-semibold mb-2 animate-fade-in">
              <FontAwesomeIcon
                icon="fa-solid fa-check-circle"
                className="mr-2 text-sky-500 bg-white rounded-full"
              />
              Anuncio Verificado
            </span>
          )}
          <h2 className="line-clamp-1 text-3xl md:text-5xl font-bold sm:mb-4 animate-fade-in">
            {item.title}
          </h2>
          <p className="md:text-xl line-clamp-1 opacity-90 animate-slide-up ">
            {item.subTitle}
          </p>
          <div
            className={`flex items-center justify-center gap-x-2 sm:mt-4 animate-fade-in`}
          >
            <button className="bg-aw-blue text-white px-3 sm:px-6 py-3 text-xs sm:text-base border rounded-3xl hover:bg-aw-blue-dark transition duration-300 scale-100 hover:scale-95">
              Seguir
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
